<template>
  <header>
    <router-link to="/" exact class="logo">
      <svg-icon icon-class="icon_logo" class-name="icon_logo"></svg-icon>
    </router-link>

    <router-link to="/try" exact class="totry">申请使用</router-link>

    <div class="navicon" @click="currentNav = !currentNav">
      <svg-icon icon-class="icon_toggle" class-name="icon_toggle"></svg-icon>
    </div>
    <transition name="draw">
      <ul class="nav" v-show="currentNav">
        <li>
          <router-link to="/" exact @click.native="routerRefresh">首页</router-link>
        </li>

        <li>
          <router-link to="/solve" @click.native="routerRefresh">解决方案</router-link>
        </li>

        <li>
          <router-link to="/service" @click.native="routerRefresh">客户服务</router-link>
        </li>

        <li>
          <router-link to="/case" @click.native="routerRefresh">客户案例</router-link>
        </li>
        <li>
          <router-link to="/about" @click.native="routerRefresh">关于我们</router-link>
        </li>

        <li class="nav-try">
          <router-link to="/try" @click.native="routerRefresh">申请使用</router-link>
        </li>
        <li>
          <a href="https://hcs.houkeyun.com/">企业登录</a>
        </li>
      </ul>
    </transition>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      currentNav: false
    };
  },
  methods: {
    routerRefresh() {
      this.$nextTick(() => {
        this.currentNav = false;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
header {
  width: 100%;
  height: 90px;
  padding: 0 32px;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 9999;
  box-shadow: 0px 15px 40px 0px rgba(0, 0, 0, 0.06);
  .logo {
    background: transparent !important;
    .icon_logo {
      width: 284px;
      height: 60px;
    }
  }
  .totry {
    display: block;
    width: 176px;
    height: 58px;
    background: #f08300;
    border-radius: 6px;
    color: #fff;
    font-size: 32px;
    font-weight: 400;
    line-height: 58px;
    text-align: center;
    margin-right: 32px;
    margin-left: auto;
  }
  .navicon {
    width: 44px;
    height: 36px;
    .icon_toggle {
      width: 100%;
      width: 100%;
    }
  }
  .nav {
    width: 100%;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 90px;
    overflow: hidden;
    z-index: 9999;
    background: rgba(22, 44, 96, 0.6);
    li {
      background: #ffffff;
      a {
        padding: 0 48px;
        display: block;
        height: 100px;
        line-height: 100px;
        font-size: 30px;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
      }
    }
  }
  .draw-enter-active,
  .draw-leave-active {
    transition: max-height 0.35s;
  }
  .draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
    max-height: 0;
  }

  .draw-enter-to,
  .draw-leave {
    max-height: 100vh;
  }
}
</style>
